const STYLE_ID = "shopify-account-close-fix";

const CLOSE_BUTTON_STYLES = `
.account__close.button {
  border-radius: var(--shopify-account-radius-button-small, 999px) !important;
  -webkit-tap-highlight-color: transparent;
}
.account__close.button:hover,
.account__close.button:focus,
.account__close.button:focus-visible,
.account__close.button:active {
  box-shadow: none !important;
  outline: none !important;
  border-radius: var(--shopify-account-radius-button-small, 999px) !important;
}
.account__close.button.subdued:hover,
.account__close.button.subdued:active {
  background-color: var(--shopify-login-form-color-background-subdued) !important;
}
`;

/**
 * @param {Element} element
 */
function patchShopifyAccountCloseButton(element) {
  if (!(element instanceof HTMLElement) || element.tagName !== "SHOPIFY-ACCOUNT") return;

  const inject = () => {
    const { shadowRoot } = element;
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = CLOSE_BUTTON_STYLES;
    shadowRoot.appendChild(style);
  };

  const observeShadow = () => {
    inject();
    const { shadowRoot } = element;
    if (!shadowRoot) return;
    const shadowObserver = new MutationObserver(inject);
    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
  };

  observeShadow();

  const hostObserver = new MutationObserver(observeShadow);
  hostObserver.observe(element, { childList: true });
}

function initShopifyAccountCloseFix() {
  document.querySelectorAll("shopify-account").forEach(patchShopifyAccountCloseButton);

  customElements.whenDefined("shopify-account").then(() => {
    document.querySelectorAll("shopify-account").forEach(patchShopifyAccountCloseButton);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.tagName === "SHOPIFY-ACCOUNT") patchShopifyAccountCloseButton(node);
        node.querySelectorAll("shopify-account").forEach(patchShopifyAccountCloseButton);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initShopifyAccountCloseFix, { once: true });
} else {
  initShopifyAccountCloseFix();
}
